export enum ApiErrorCode {
  UnknownError = -1,
  Unauthorized = 1,
  Forbidden = 2,
  ValidationError = 5
}
